import { ICON_PATHS } from "../icons";
import { tokens } from "../tokens";
import type { IconProps } from "../types";

/**
 * ADR-20260917-3qv1. Inline SVG, no `@mui/icons-material` dependency.
 * Decorative by default (no ARIA role) — supplying `title` makes it a
 * meaningful image (`role="img"` + accessible name), per
 * ADR-20260824-ganm. This is a self-built component, not a Material UI
 * re-export, so it deliberately does not live under `components/` next to
 * the Material UI adapters in spirit — but it does live in this directory
 * because `design-system/` is the only place `@mui/*` may be imported and
 * this file is not exempt from being enumerated by the barrel completeness
 * check (ADR-20260824-hxc9).
 */
export function Icon({ name, size = 24, tone, title, testId }: Readonly<IconProps>) {
  const decorative = title === undefined;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="currentColor"
      style={tone === "muted" ? { color: tokens.colour.brand[500], flex: "0 0 auto", display: "block" } : undefined}
      role={decorative ? undefined : "img"}
      aria-hidden={decorative ? true : undefined}
      aria-label={title}
      data-testid={testId}
    >
      {title !== undefined ? <title>{title}</title> : null}
      <path d={ICON_PATHS[name]} />
    </svg>
  );
}
